import { inject } from "@angular/core";
import { HttpInterceptorFn } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";

const skippedURLs = ["auth/login"];

function shouldSkip(requestURL: string): boolean {
  return skippedURLs.some((skipURL) => requestURL.includes(skipURL));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (shouldSkip(req.url)) {
    return next(req);
  }

  const authService = inject(AuthService);
  const accessToken = authService.getAccessToken();

  if (!accessToken) {
    return next(req);
  }

  const clonedReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  return next(clonedReq);
};
